import { AgGridReact } from "ag-grid-react";
import {
  onFirstDataRendered,
  dateComparator,
  exportSeparator,
  AG_GRID_LANGUAGE_ES,
  filterParams,
  currencyFormatter,
  timeStamp,
  defaultColDef,
} from "../../../helpers/tablaConfig";

import { Button } from "react-bootstrap";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";

import { useEffect, useState, useMemo } from "react";

export default function InscripcionFinalesTable({
  data,
  accion,
  btnIcon,
  btnVariant,
  btnTitle,
  ocultar,
}) {
  const [gridApi, setGridApi] = useState([]);
  const [gridColumnApi, setGridColumnApi] = useState([]);
  const [tiempoImpresion, setTiempoImpresion] = useState(null);

  const gridOptions = useMemo(() => {
    return {
      flex: 1,
      wrapText: true,
      sortable: true,
      resizable: true, // permite cambiar el acho de la columna
      unSortIcon: true,
      filter: true,
      floatingFilter: false,
      animateRows: true,
      minWidth: 100,
    };
  }, [data]);

  const onGridReady = (params) => {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
    params.api.sizeColumnsToFit(); // Ajusta automáticamente el ancho de las columnas
  };

  const onBtExport = () => {
    exportSeparator(gridApi);
  };

  useEffect(() => {
    setTiempoImpresion(timeStamp());
  }, []);

  const btnInscripcion = (params) => {
    return (
      <Button
        style={{ height: 25, lineHeight: 1 }}
        onClick={() => accion({ mesaSelected: params })}
        variant={btnVariant}
        data-toggle="tooltip"
        data-placement="top"
        title={btnTitle}
        disabled={params.data.disabled}
      >
        {btnIcon} {params.data.btnText}{" "}
      </Button>
    );
  };

  let filterParamsEstado = {
    filterType: "text",
    type: "equals",
    filter: "DISPONIBLE",
  };
  const columnDef = [
    {
      headerName: "",
      field: "accion",
      sortable: false,
      unSortIcon: false,
      filter: false,
      floatingFilter: false,
      resizable: true,
      maxWidth: 80,
      cellStyle: {
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
      cellRendererFramework: (params) => btnInscripcion(params),
    },
    {
      headerName: "Mesa",
      field: "id",
      resizable: true,
      maxWidth: 150,
      cellStyle: { textAlign: "right" },
    },
    {
      headerName: "Matéria",
      field: "materia",
      cellStyle: { textAlign: "right", "white-space": "normal" },
      resizable: true,
    },
    {
      headerName: "Importe",
      field: "importe",
      cellStyle: { textAlign: "right" },
      cellRenderer: currencyFormatter,
      hide: ocultar,
      maxWidth: 150,
    },
    {
      headerName: "Fecha",
      field: "fechaExamen",
      cellStyle: { textAlign: "center" },
      filter: "agDateColumnFilter",
      filterParams: filterParams,
      comparator: dateComparator,
      maxWidth: 150,
    },
    {
      headerName: "Hora",
      field: "horaExamen",
      cellStyle: { textAlign: "center" },
      maxWidth: 150,
    },
    {
      headerName: "Profesor(es)",
      field: "profes",
      cellStyle: { textAlign: "left", "white-space": "normal" },
    },
  ];

  return (
    <div>
      <div
        id="notasGrid"
        className="ag-theme-material"
        style={{ height: 300, width: "100%" }}
      >
        <AgGridReact
          rowData={data}
          onGridReady={onGridReady}
          pagination={true}
          defaultColDef={defaultColDef}
          paginationPageSize={10}
          localeText={AG_GRID_LANGUAGE_ES}
          onFirstDataRendered={onFirstDataRendered}
          columnDefs={columnDef}
          animateRows={true}
          resizable={true}
          gridOptions={gridOptions}
        />
      </div>
    </div>
  );
}
